export const ARTICLE_TYPES = {
  article: { label: 'Article' },
  long_social_post: { label: 'Long Social Post' },
  short_social_post: { label: 'Short Social Post' },
  image_carousel: { label: 'Image Carousel' },
  short_video: { label: 'Short Video' },
  long_video: { label: 'Long Video' }
};

export const ARTICLE_SUBTYPES = {
  // Article subtypes
  how_to: { label: 'How-To Guide' },
  list_article: { label: 'List Article' },
  review: { label: 'Review' },
  opinion: { label: 'Opinion' },
  news: { label: 'News' },
  case_study: { label: 'Case Study' },
  
  // Short social post subtypes
  instagram_post: { label: 'Instagram Post' },
  x_post: { label: 'X/Twitter Post' },
  facebook_post: { label: 'Facebook Post' },
  linkedin_short: { label: 'LinkedIn Short' },
  threads_post: { label: 'Threads Post' },
  
  // Long social post subtypes
  linkedin_article: { label: 'LinkedIn Article' },
  facebook_long: { label: 'Facebook Long Post' },
  medium_story: { label: 'Medium Story' },
  x_thread: { label: 'X/Twitter Thread' },
  
  // Image carousel subtypes
  instagram_carousel: { label: 'Instagram Carousel' },
  linkedin_carousel: { label: 'LinkedIn Carousel' },
  facebook_carousel: { label: 'Facebook Carousel' },
  
  // Short video subtypes
  tiktok: { label: 'TikTok' },
  instagram_reel: { label: 'Instagram Reel' },
  youtube_short: { label: 'YouTube Short' },
  
  // Long video subtypes
  youtube_video: { label: 'YouTube Video' },
  vimeo_video: { label: 'Vimeo Video' },
  course_video: { label: 'Course Video' }
};

export const ARTICLE_STATUSES = {
  backlog: { label: 'Backlog', color: 'default' },
  todo: { label: 'To Do', color: 'default' },
  in_progress: { label: 'In Progress', color: 'primary' },
  finished: { label: 'Finished', color: 'success' },
  scheduled: { label: 'Scheduled', color: 'info' },
  published: { label: 'Published', color: 'success' },
  archived: { label: 'Archived', color: 'error' }
};

// Helper functions
export const getTypeLabel = (type) => ARTICLE_TYPES[type]?.label || type;
export const getSubtypeLabel = (subtype) => ARTICLE_SUBTYPES[subtype]?.label || subtype;
export const getStatusLabel = (status) => ARTICLE_STATUSES[status]?.label || status;
export const getStatusColor = (status) => ARTICLE_STATUSES[status]?.color || 'default';

// Platform-specific helpers
export const getPlatformContext = (subtype) => {
  if (!subtype) return null;
  
  if (subtype.includes('linkedin')) return "LinkedIn's professional audience";
  if (subtype.includes('facebook')) return "Facebook's community";
  if (subtype.includes('instagram')) return "Instagram's visual platform";
  if (subtype.includes('x') || subtype.includes('twitter')) return "X/Twitter's format";
  if (subtype.includes('medium')) return "Medium's reading experience";
  if (subtype.includes('threads')) return "Threads' conversational style";
  return 'your chosen platform';
}; 